/** 쓰다 만 글(초안)과 예약 전송 */
import { z } from "zod";
import type { AttachmentDTO } from "./index";

const id = z.number().int().positive();

/** 초안이 놓인 곳: 채널이나 DM 하나 (+ 스레드 원글) */
const place = {
  channelId: id.optional(),
  conversationId: id.optional(),
  parentId: id.optional(),
};
const onePlace = (v: { channelId?: number; conversationId?: number }) => (v.channelId === undefined) !== (v.conversationId === undefined);

/** 빈 글이면 초안을 지운다 */
export const saveDraftInput = z.object({ ...place, body: z.string().max(8000, "메시지는 8000자까지입니다.") }).refine(onePlace, { message: "채널이나 DM 하나를 정하세요." });

export const draftKey = (p: { channelId?: number | null; conversationId?: number | null; parentId?: number | null }) =>
  `${p.channelId ? `c:${p.channelId}` : `d:${p.conversationId}`}${p.parentId ? `:t:${p.parentId}` : ""}`;

export interface DraftDTO {
  id: number;
  key: string;
  channelId: number | null;
  conversationId: number | null;
  parentId: number | null;
  body: string;
  updatedAt: string;
}

/** 입력을 멈추고 이만큼 지나면 초안을 저장한다 */
export const DRAFT_SAVE_MS = 2500;

/** 예약은 지금부터 1분 뒤 ~ 1년 안 */
export const SCHEDULE_MIN_MS = 60 * 1000;
export const SCHEDULE_MAX_MS = 366 * 24 * 60 * 60 * 1000;

export const scheduleMessageInput = z
  .object({
    ...place,
    body: z.string().trim().max(8000, "메시지는 8000자까지입니다.").default(""),
    attachmentIds: z.array(id).max(10, "파일은 한 번에 10개까지 보낼 수 있습니다.").default([]),
    alsoInChannel: z.boolean().optional(),
    sendAt: z.iso.datetime(),
  })
  .refine(onePlace, { message: "채널이나 DM 하나를 정하세요." })
  .refine((v) => v.body.length > 0 || v.attachmentIds.length > 0, { message: "메시지를 입력하세요.", path: ["body"] });

export const updateScheduledInput = z.object({
  sendAt: z.iso.datetime().optional(),
  body: z.string().trim().min(1, "메시지를 입력하세요.").max(8000, "메시지는 8000자까지입니다.").optional(),
});

export interface ScheduledMessageDTO {
  id: number;
  channelId: number | null;
  conversationId: number | null;
  parentId: number | null;
  alsoInChannel: boolean;
  body: string;
  attachments: AttachmentDTO[];
  sendAt: string;
  status: "pending" | "sending" | "failed";
  /** 보내지 못한 까닭 */
  error: string | null;
  createdAt: string;
}
